import React from 'react';
import { mediaUrl } from '../utils/media';
import { DONATE_URL } from '../utils/donate';

const AboutSection: React.FC = () => {

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
            <div className="position-relative overflow-hidden h-100" style={{ minHeight: '400px' }}>
              <img
                className="position-absolute w-100 h-100 pt-5 pe-5"
                src={mediaUrl('Photo from Anand Mashatte(14).jpg')}
                alt="About"
                style={{ objectFit: 'cover' }}
              />
              <img
                className="position-absolute top-0 end-0 bg-white ps-2 pb-2"
                src={mediaUrl('about-2.jpg')}
                alt="About"
                style={{ width: '200px', height: '200px' }}
              />
            </div>
          </div>
          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="500">
            <div className="h-100">
              <div className="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3">
                About Us
              </div>
              <h1 className="display-6 mb-5">We Help People In Need Around The World</h1>
              <div className="bg-light border-bottom border-5 border-primary rounded p-4 mb-4">
                <p className="text-dark mb-2">
                  Together, we make a difference. Every contribution helps us reach more people in need and create lasting positive change in communities around the world.
                </p>
                <span className="text-primary">Humanity Trust, Founder</span>
              </div>
              <p className="mb-5">
                Humanity Trust is dedicated to creating a better world through compassion, care, and community building. We provide essential resources, education, healthcare, and support to those in need, empowering individuals and communities to thrive.
              </p>
              <a
                className="btn btn-primary py-2 px-3 me-3"
                href={DONATE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Donate Now
                <div className="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2">
                  <i className="fa fa-arrow-right"></i>
                </div>
              </a>
              <a className="btn btn-outline-primary py-2 px-3" href="/contact">
                Contact Us
                <div className="d-inline-flex btn-sm-square bg-primary text-white rounded-circle ms-2">
                  <i className="fa fa-arrow-right"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;

